import cx from 'classnames';
import Select from 'react-select';

import { AppearDown } from '../../transitions/AppearDown/appear-down';
import { Controller } from 'react-hook-form';
import { GKSelectOption } from '@greenkub-fronts/shared/interface';

type SelectOption = { value: string; label: string };

export interface GKSelectProps {
  placeholder?: string;
  name: string;
  options: SelectOption[];
  errorMsg?: string | null;
  defaultValue?: any;
  isMulti?: boolean;
  style?: any;
  className?: string;
  customOnChange?: Function;
  control?: any;
  required?: boolean;
  menuPlacement?: any;
}

export const GKSelect = (props: GKSelectProps) => {
  const {
    placeholder = '',
    name,
    options,
    errorMsg = null,
    defaultValue,
    customOnChange,
    isMulti = false,
    style = {},
    className = '',
    control = false,
    required,
    menuPlacement,
  } = props;

  const getOption = (value?: string) => {
    if (isMulti) {
      const tmpOpt = options.filter((opt: SelectOption) =>
        defaultValue?.includes(opt.value)
      );
      return tmpOpt;
    }

    if (value) {
      return options.find((opt) => opt.value === value);
    } else {
      return options.find((opt) => opt.value === defaultValue);
    }
  };

  const customValue = (value: any) => {
    if (isMulti) {
      return options.filter((opt) => value.includes(opt.value));
    } else {
      return options.find((opt) => opt.value === value);
    }
  };

  const onChangeCustom = (selectedOptions: any, onChange: Function) => {
    if (isMulti && Array.isArray(selectedOptions)) {
      const selectedValues = (selectedOptions as SelectOption[]).map(
        (option: any) => option.value
      );
      return onChange(selectedValues);
    } else {
      return onChange(selectedOptions.value);
    }
  };

  return (
    <div style={style} className={cx('GKInput-select', className)}>
      {control ? (
        <Controller
          control={control}
          name={name}
          defaultValue={isMulti ? [] : false}
          render={({ field: { onChange, value } }) => {
            return (
              <Select
                isMulti={isMulti}
                name={name}
                value={customValue(value)}
                options={options}
                onChange={(selectedOptions) => {
                  onChangeCustom(selectedOptions, onChange);
                }}
                placeholder={placeholder}
                classNamePrefix="GKInput-select"
                menuPlacement={menuPlacement}
              />
            );
          }}
        />
      ) : (
        <Select
          isMulti={isMulti}
          name={name}
          value={getOption()}
          placeholder={placeholder}
          options={options}
          // selectOption={(option) => customOnChange ? customOnChange(option.value) : onChange(option.value)}
          onChange={(option: any) =>
            customOnChange && customOnChange(option.value)
          }
          classNamePrefix="GKInput-select"
          menuPlacement={menuPlacement}
        />
      )}

      <AppearDown
        isActive={errorMsg !== null && errorMsg !== undefined}
        duration=".3s"
      >
        <div>
          <span className="form-msg is-error">{errorMsg}</span>
        </div>
      </AppearDown>
    </div>
  );
};

export default GKSelect;
